import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { VisaDesignerService } from '../visa-designer.service';
// import { DeleteDialogLibraryComponent } from 'delete-dialog-library';
import { ToastrService } from 'ngx-toastr';
import { ImagilityBaseResponse } from 'app-models';
import { ConfirmationService } from 'primeng/api';
import { Store } from '@ngrx/store';
import { UploadPdfService } from '../upload-pdf/upload-pdf.service';
import { environment } from 'src/environments/environment';

// export const DeleteDialogConfigurations = {
//   width: '30%',
//   closeOnEscape: false,
//   closable: false,
//   showHeader: false,
//   contentStyle: { "z-index": "1001" }
// };

@Component({
  selector: 'app-vd-created-list',
  templateUrl: './vd-created-list.component.html',
  styleUrls: ['./vd-created-list.component.scss']
})

export class VdCreatedListComponent implements OnInit, OnDestroy {
  visaList: any[] = [];
  columns = [];
  observableSubscription$ = new Subject();
  recordsPerPage = 25;
  totalCount = 0;
  requestPayload: {
    'countryCode'?: string,
    'formType'?: string,
    'id'?: number,
    'pageNumber'?: number,
    'pageSize'?: number,
    'petitionType'?: string,
    'recordsPerPage'?: number,
    'searchText'?: string,
    'subTaskType'?: string,
    'visaType'?: string,
    'immCategory': string,
    'immClassification': string,
  } = {
      countryCode: '',
      formType: '',
      id: 0,
      pageNumber: 1,
      pageSize: 25,
      petitionType: '',
      recordsPerPage: this.recordsPerPage,
      searchText: '',
      subTaskType: '',
      visaType: '',
      immCategory: '',
      immClassification: '',
    };
  isDevMode: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vdService: VisaDesignerService,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private store: Store<any>,
    private uploadPdfService: UploadPdfService
  ) { }

  ngOnInit(): void {
    localStorage.setItem('isEditVisa', 'false');
    this.columns = [
      { columnDef: 'visaName', header: 'VISA NAME', columnType: 'text', customClass: 'mouse-pointer' },
      { columnDef: 'country', header: 'COUNTRY', columnType: 'text', customClass: '' },
      { columnDef: 'formType', header: 'FORM TYPE', columnType: 'text', customClass: '' },
      { columnDef: 'visaType', header: 'VISA TYPE/IMMIGIRATION CATAGORY', columnType: 'options', customClass: '' },
      { columnDef: 'petitionType', header: 'PETITION TYPE/IMMIGIRATION CLASSIFICATION', columnType: 'options', customClass: '' },
      { columnDef: 'subTaskType', header: 'SUB TASK', columnType: 'text', customClass: '' },
      { columnDef: 'language', header: 'LANGUAGE', columnType: 'text', customClass: '' },
      { columnDef: 'publishedOn', header: 'PUBLISHED ON', columnType: 'date', customClass: '' },
      { columnDef: 'action', header: 'Actions', columnType: 'action', customClass: '' }];

    this.vdService.manageVisaFilterChanged.subscribe((response) => {
      this.requestPayload = {
        ... this.requestPayload,
        ...response
      };
      this.loadCreatedVisa();
    });
    if(environment.appUrl === 'http://3.88.240.163'){
      this.isDevMode = true;
    }
    this.loadCreatedVisa();
  }
  handlePageChange(e) {
    this.requestPayload.pageNumber = e.page + 1;
    this.requestPayload.pageSize = e.rows;
    // this.requestPayload.pageNumber = e?.page || 1;
    this.loadCreatedVisa();
  }
  loadCreatedVisa() {
    this.vdService.getCreatedVisaList(this.requestPayload).pipe(
      takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        if (response.status === 200) {
          this.totalCount = response?.data?.totalCount;
          this.visaList = response?.data.result || [];
        } else {
          this.visaList = [];
        }
      });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }
  handleEdit(id) {
    this.router.navigate([`../../visa-builder/create-visa/${id}`], { relativeTo: this.route });
    localStorage.setItem('isEditVisa', 'true');
    localStorage.setItem('visaId', id);
  }
  handleView(id) {
    this.router.navigate([`../../visa-builder/create-visa/${id}/view`], { relativeTo: this.route });
    localStorage.setItem('isEditVisa', 'false');
    localStorage.setItem('visaId', id);
  }
  handleDuplicate(visaId) {
    this.router.navigate([`../../visa-builder/create-visa/${visaId}/duplicate`], { relativeTo: this.route });
    localStorage.setItem('isEditVisa', 'false');
    localStorage.setItem('visaId', visaId);
  }
  handleRepublish(visaId) {
    this.router.navigate([`../../visa-builder/create-visa/${visaId}/republish`], { relativeTo: this.route });
    localStorage.setItem('visaId', visaId);
  }

  handleDelete(visaId) {
    localStorage.setItem('isEditVisa', 'false');
    // const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
    // deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: boolean) => {
    //   if (response) {
    //     this.vdService.deleteVisa(
    //       visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
    //         this.toastr.success(response.message);
    //         this.loadCreatedVisa();
    //       });
    //   }
    // });

    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete',
      accept: () => {
        this.vdService.deleteVisa(
          visaId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
            this.toastr.success(response.message, 'Success');
            this.loadCreatedVisa();
          });
      },
      reject: () => {
      }
    });


  }

}
